import { alert } from 'vue-strap'

export default {
    extends: alert,
    mounted () { this.syncAccessibility() },
    updated () { this.syncAccessibility() },
    methods: {
        syncAccessibility () {
            this.$el.setAttribute('role', this.type === 'danger' ? 'alert' : 'status')
            this.$el.setAttribute('aria-atomic', 'true')
            const close = this.$el.querySelector('button.close')
            if (close) close.setAttribute('aria-label', 'Dismiss message')
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Alert.js